import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { SortType } from '../../api/generated';
import { useSTColumn } from '../../table/SmartTableContext';
import { defineStyles } from '../../theme';
const styles = defineStyles({
    button: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 0,
        opacity: 0,
        transition: 'width 0.07s ease, opacity 0.07s ease',
        paddingBlock: 0.25,
        paddingInline: 0,
    },
    buttonOpen: {
        width: 28,
        opacity: 1,
    },
    buttonIcon: {
        width: 24,
        height: 24,
    },
    itemIcon: {
        mr: 0.5,
    },
});
function TableHeaderMoreButton({ cell }) {
    const { removeSorting, setSorting } = useSTColumn(cell);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleAddSorting = (e) => {
        e.stopPropagation();
        setSorting(SortType.Asc);
        handleClose();
    };
    const handleRemoveSorting = (e) => {
        e.stopPropagation();
        removeSorting();
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: handleClick, sx: { ...styles.button, ...(open && styles.buttonOpen) }, className: "table-header-more-button", disableRipple: true, children: _jsx(MoreVertIcon, { sx: styles.buttonIcon }) }), _jsxs(Menu, { anchorEl: anchorEl, onClose: handleClose, open: open, children: [_jsxs(MenuItem, { onClick: handleAddSorting, children: [_jsx(AddIcon, {}), _jsx(FormattedMessage, { id: "table.sorting.add_to_sort.button", defaultMessage: "Add to sort" })] }), _jsxs(MenuItem, { onClick: handleRemoveSorting, children: [_jsx(RemoveIcon, { sx: styles.itemIcon }), _jsx(FormattedMessage, { id: "table.sorting.remove_from_sort.button", defaultMessage: "Remove from sort" })] })] })] }));
}
export default TableHeaderMoreButton;
//# sourceMappingURL=TableHeaderMoreButton.js.map